import React from "react";
import {
  MessageCircle, Users, Puzzle, ShieldCheck, Repeat, Crown, HeartHandshake,
  Swords, Clock, GitBranch, TrendingUp, Ear, CheckSquare, BatteryCharging, HelpCircle,
} from "lucide-react";

// One icon per competency, shared between the allocation screen and the generating
// loader so both read as one system instead of two different visual languages for
// the same competency. Falls back to HelpCircle for any future competency this map
// hasn't caught up with yet.
const COMPETENCY_ICONS = {
  "Communication": MessageCircle,
  "Teamwork": Users,
  "Problem-Solving": Puzzle,
  "Ownership/Accountability": ShieldCheck,
  "Adaptability": Repeat,
  "Leadership": Crown,
  "Emotional Intelligence": HeartHandshake,
  "Conflict Management": Swords,
  "Time Management": Clock,
  "Decision-Making": GitBranch,
  "Learning Agility": TrendingUp,
  "Openness to Feedback": Ear,
  "Conscientiousness": CheckSquare,
  "Stress Management": BatteryCharging,
};

export const iconFor = (name) => COMPETENCY_ICONS[name] || HelpCircle;

export const CompetencyIconTile = ({ name, size = "md" }) => {
  const Icon = iconFor(name);
  const dims = size === "sm" ? "w-7 h-7" : "w-8 h-8";
  const iconSize = size === "sm" ? 13 : 15;
  return (
    <div className={`shrink-0 ${dims} rounded-lg flex items-center justify-center bg-[#5A4479]/15`}>
      <Icon size={iconSize} className="dark:text-[#DAC0FF] text-[#5A4479]" />
    </div>
  );
};
